<template>
  <div id="app-reviews" tabindex="0" @keydown.escape="ratingsModalVisible = false">
    <!-- MODAL -->
    <div :class="`product-reviews-modal ${ratingsModalVisible ? 'visible' : ''}`" v-show="ratingsModalVisible"
      @click="ratingsModalVisible = false">
      <div class="content relative" @click.stop>
        <div class="-right-3.5 -top-3.5 absolute bg-white cursor-pointer rounded-full"
          @click="ratingsModalVisible = false">
          <font-awesome-icon :icon="['fas', 'circle-xmark']" size="2xl"
            style="color: #000000; transform: scale(1.05);" />
        </div>
        <h3 class="pb-2 text-center mb-0 sm:mb-auto" v-if="productName">
          {{ productName }}
        </h3>
        <RatingsView :reviews="reviews" :dateFormat="dateFormat" :lexicon="lexicon"
          v-if="reviews && reviews.reviews && lexicon" />
      </div>
    </div>

    <!-- PRODUCT VIEW -->
    <div v-if="!isCategoryView">
      <div v-if="targetTitle && reviews && reviews.reviews.length > 0">
        <div v-dom-portal="targetTitle">
          <div class="w-full pt-2" v-if="productViewReviewsHtml" v-html="productViewReviewsHtml"></div>
          <div class="cursor-pointer flex items-center title-link" style="-webkit-tap-highlight-color: transparent"
            @click="ratingsModalVisible = true">
            <star-rating :increment="0.2" :star-size="isMobile() ? mobileLinkStarSize : 20"
              :padding="isMobile() ? 1 : 0" :glow="0.5" read-only inline :show-rating="false"
              :rating="reviews.average" />
            <span :class="`title-text ${linkSize || 'small'}`">
              {{ reviews.total }} {{ lexicon.reviews }}
            </span>
          </div>
        </div>
      </div>

      <div v-if="targetBelow && lexicon && reviews && reviews.reviews.length > 0">
        <div class="sm:py-5 py-3 px-3" v-dom-portal="targetBelow">
          <div class="border-t mt-4 border-gray-200 pt-4">
            <h4 class="pb-2 font-bold text-center mb-0 sm:mb-auto">
              Product reviews
            </h4>
            <RatingsView :reviews="reviews" :dateFormat="dateFormat" :lexicon="lexicon" />
          </div>
        </div>
      </div>
    </div>
    <!-- CATEGORY VIEW -->
    <div v-else>
      <div v-for="(product, index) in categoryProducts" :key="`product-${index}`">
        <div v-if="product.target" v-dom-portal="`${product.target} ${isWebsiteWithSubtitle
          ? '.m-product-archive-subtitle'
          : '.name.nasa-show-one-line'
          } `
          " :class="`${isWebsiteWithSubtitle ? 'p-1' : ''} cursor-pointer`" @click="ratingsModalVisible = true">
          <star-rating :increment="0.2" :star-size="20" :glow="0.5" read-only inline :show-rating="false"
            :rating="Math.floor(Math.random() * (5 - 0 + 1)) + 0" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
import RatingsView from "./components/RatingsView.vue";

import { getProductReviews } from "./assets/api";
import { isMobile } from "@/assets/helpers.js";

export default {
  name: "App",
  components: {
    StarRating,
    RatingsView,
  },
  data() {
    return {
      targetTitle: null,
      targetBelow: null,
      ratingsModalVisible: false,
      productName: null,
      reviews: null,
      dateFormat: null,
      lexicon: null,
      isCategoryView: false,
      categoryProducts: [],
      isWebsiteWithSubtitle: null,
      productViewReviewsHtml: null,
      isMobile,
      linkSize: null,
    };
  },
  computed: {
    mobileLinkStarSize() {
      if (this.linkSize === 'small') return 15;
      else if (this.linkSize === 'medium') return 17;
      else if (this.linkSize === 'large') return 19;
      else return 15;
    }
  },
  watch: {
    // isWebsiteWithSubtitle() {
    //   console.log("iswebsite with subtitle: ", this.isWebsiteWithSubtitle);
    // },
  },
  methods: {
    setTarget() {
      const before = ".price.nasa-single-product-price";
      const parent = ".nasa-product-info-scroll";
      const beforeElement = document.querySelector(before);
      const parentElement = document.querySelector(parent);
      const newElement = document.createElement("div");
      newElement.className = "new-product-reviews-title";
      // console.log(beforeElement, parentElement);

      if (beforeElement && parentElement) {
        parentElement.insertBefore(newElement, beforeElement);
        this.targetTitle = ".new-product-reviews-title";
      }
    },
    setTargetBelow() {
      let element;

      element = document.querySelector("#main-content");
      console.log(element);
      if (element) {
        this.targetBelow = "#main-content";
      }
    },
    categoryView() {
      const products = document.querySelectorAll(
        ".product-warp-item .product.type-product"
      );
      products?.forEach((product) => {
        const target = "." + [...product?.classList]?.join(".");
        const index = this.categoryProducts.findIndex(
          (prod) => prod.target === target
        );
        if (index < 0)
          this.categoryProducts.push({
            element: product,
            target,
          });
      });
    },
    prepareForCategoryView() {
      if (!window.location.search.includes("cat-ratings")) {
        return;
      }

      this.categoryView();
      document.addEventListener("new-page-success", () => {
        setTimeout(() => this.categoryView(), 1500);
      });
    },
  },
  async mounted() {
    console.log("product reviews plugin loaded!");
    this.productIds = window.productReviews?.apiIds;
    if (this.productIds)
      this.reviews = await getProductReviews(this.productIds);
    this.dateFormat = window.productReviews?.options?.dateFormat;
    this.linkSize = window.productReviews?.options?.ratingsLinkSize;
    this.lexicon = window.productReviews?.options?.lexicon;
    this.isCategoryView = window.productReviews?.isCategoryView;
    this.productViewReviewsHtml = window.productReviews?.productViewReviewsHtml;
    if (this.isCategoryView) {
      this.prepareForCategoryView();
    }

    this.productName = window.productReviews?.name;
    this.isWebsiteWithSubtitle = !!document.querySelector(
      ".m-product-archive-subtitle"
    );
    setTimeout(() => {
      this.setTarget();
      this.setTargetBelow();
    }, 3000);
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}

.vue-star-rating {
  justify-content: center;
}

.vue-star-rating-rating-text {
  margin-left: 4px;
  margin-top: 5px;
}

body:has(.product-reviews-modal.visible) {
  overflow: hidden;
}
</style>

<style lang="scss" scoped>
.product-reviews-modal {
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999999999;
  display: flex;
  justify-content: center;
  align-items: center;

  .content {
    // max-width: 90vw;
    max-height: 80vh;
    padding: 20px;
    background: #fff;
    border-radius: 10px;
    // min-width: 300px;
    min-height: 600px;
    width: 85vw;

    @media screen and (max-width: 600px) {
      width: 90vw;
      height: 90vh;
      padding: 15px;
    }
  }
}

.title-link {
  &:hover {
    .title-text {
      text-decoration: underline;
    }
  }
}

.title-text {
  font-size: 18px;
  margin-left: 10px;
  margin-top: 5px;

  @media screen and (max-width: 600px) {
    &.small {
      font-size: 13px;
    }

    &.medium {
      font-size: 15px;
    }

    &.large {
      font-size: 17px;
    }
  }
}
</style>
